import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import { MAX_PAGE_SIZE } from '@/lib/api/max-page-size';

import { POSITION_QUERY_KEY } from './key';
import type { PositionItem } from './type';

export const fetchPositions = async (
  freeText: string,
): Promise<PositionItem[]> => {
  const res = await apiClient.GET(POSITION_QUERY_KEY, {
    params: { query: { freeText, pageSize: MAX_PAGE_SIZE } },
  });
  const data = getDataOrThrowApiError(res);
  return data.items;
};
